/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackGridItemViewModel } from "../types/FeedbackGridItemViewModel.ts";
import { eFeedbackTypeSchema } from "./eFeedbackTypeSchema.ts";

export const feedbackGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  title: z.string().nullish(),
  feedbackType: z.optional(
    z
      .lazy(() => eFeedbackTypeSchema)
      .describe("1 = Numeric | 2 = LikeAndDislike | 3 = LikeOnly | "),
  ),
  feedbackTypeText: z.string().nullish(),
  isGlobal: z.optional(z.boolean()),
  showComment: z.boolean().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<FeedbackGridItemViewModel>;
